import { ComponentConfirmationState } from "@redotech/redo-model/conversation";
import { ComponentStateMessage } from "@redotech/redo-model/conversation/conversation-message-db-parser";
import { assertNever } from "@redotech/util/type";
import { memo, ReactNode } from "react";

interface ChatContentRendererProps {
  message: ComponentStateMessage;
  contentByState: {
    pending?: ReactNode;
    confirmed?: ReactNode;
    rejected?: ReactNode;
  };
}

/**
 * This component serves as a wrapper for all components that are to be rendered by the chat widget.
 * It manages the component state lifecycle (pending, confirmed, rejected) and renders
 * the appropriate content based on the current state.
 */
export const ChatContentRenderer = memo(function ChatContentRenderer({
  message,
  contentByState,
}: ChatContentRendererProps) {
  const confirmationState: ComponentConfirmationState =
    message.confirmationStateInformation?.confirmationState ??
    ComponentConfirmationState.PENDING;

  switch (confirmationState) {
    case ComponentConfirmationState.PENDING:
      return <>{contentByState.pending || null}</>;
    case ComponentConfirmationState.CONFIRMED:
      return <>{contentByState.confirmed || null}</>;
    case ComponentConfirmationState.REJECTED:
      return <>{contentByState.rejected || null}</>;
    default:
      assertNever(confirmationState);
  }
});
